import React from 'react'
import Messages from '../constants/messages'
import { minCharacters, notContainEmail, notContainPassword, notBeQuestionPart } from '../utils/validationRules';
import { PropTypes } from 'prop-types';

const PROP_TYPES = {
  answer:PropTypes.string,
  classes:PropTypes.object,
  email:PropTypes.string,
  password:PropTypes.string,
  question:PropTypes.string
}

  // Okta Security Question Requirements:
  // https://support.okta.com/help/s/article/What-are-the-requirements-for-a-valid-security-question-answer
 export function SecurityQuestionRequirements(props) {
  const {
    answer,
    classes,
    email,
    password,
    question
  } = props
  return (
    <div>
      <ul>
        <li data-test-id="length-check" className={minCharacters(answer) ? null : classes.confirmCheck}>{Messages['tooltips']['SECURITY_QUESTIONS_POLICY1']}</li>
        <li data-test-id="username-check" className={notContainEmail(answer, {email}) ? null : classes.confirmCheck}>{Messages['tooltips']['SECURITY_QUESTIONS_POLICY2']}</li>
        <li data-test-id="password-check" className={notContainPassword(answer, {password}) ? null : classes.confirmCheck}>{Messages['tooltips']['SECURITY_QUESTIONS_POLICY3']}</li>
        <li data-test-id="question-check" className={notBeQuestionPart(answer, {question}) ? null : classes.confirmCheck}>{Messages['tooltips']['SECURITY_QUESTIONS_POLICY4']}</li>
      </ul>
    </div>
  )
}

SecurityQuestionRequirements.propTypes = PROP_TYPES

